import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="pt-16 pb-20 px-4 md:pt-24 md:pb-32 overflow-hidden bg-brand-black" data-id="element-45">
      <div className="max-w-5xl mx-auto text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-green/15 text-brand-green font-body font-bold text-sm tracking-wider uppercase mb-6 border border-brand-green/30" data-id="element-48">
            Exclusivo para Zurdos
          </span>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[1.1] mb-10 uppercase" data-id="element-49">
            Dominá el pádel en{' '}
            <span className="text-brand-green" data-id="element-50">8 semanas</span> con la ventaja
            del zurdo
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center mb-10" data-id="element-51">
          <div className="absolute inset-0 bg-brand-green/20 blur-[100px] rounded-full max-w-md mx-auto" data-id="element-52"></div>
          <a href="#compra" className="relative z-10 block" data-id="element-53">
            <img src="https://cdn.magicpatterns.com/uploads/681jmHSvA34PM4joXcyoEf/ChatGPT_Image_May_5__2026__04_12_26_PM-removebg-preview.png" alt="Padel Zurdo Pro Bundle" className="w-3/4 max-w-2xl mx-auto drop-shadow-2xl" data-id="element-54" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-body text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 font-medium" data-id="element-55">
          El sistema definitivo de tácticas, ejercicios y estrategias diseñado
          exclusivamente para jugadores zurdos de pádel.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-56">
          <a href="https://checkout.ebookpoint.shop/cart/59466975805521:1" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-xl md:text-2xl py-5 px-10 rounded-xl transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto" data-id="element-57">
            QUIERO USAR MI ZURDA COMO VENTAJA
            <ChevronRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-58" />
          </a>
          <p className="font-body text-sm text-gray-400 mt-4 flex items-center justify-center gap-2" data-id="element-59">
            <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-60"></span>
            Acceso inmediato tras la compra
          </p>
        </motion.div>
      </div>
    </section>;
}